import React from 'react'
import { FormControl, MenuItem, TextField } from '@mui/material'
import View from '../../atoms/view'
import theme from '../../../theme'

const textStyle = {
  fontFamily: 'Inter',
  fontWeight: 400,
  color: theme.colors.tableText
}

export const Dropdown = ({ noBorder, addOptionNone, options, placeholder, value, onChange, isRequired, title, disabled, size }) => {

  const valueExistsInOptions = options?.some(
    (option) => (option.value ?? option.id ?? option.name) === value
  )
  
  return (
    <View>
      <View style={{ display: 'flex', flexDirection: 'row', gap: 5 }}>
        {isRequired ? <View style={{ color: theme.colors.error }}>*</View> : null}
        <Title>{title}</Title>
      </View>
      <FormControl fullWidth size={size ?? 'small'}>
        <TextField
          select
          size={size ?? 'small'}
          disabled={disabled}
          label={value ? '' : placeholder}
          id="demo-simple-select"
          variant={noBorder ? 'standard' : 'outlined'}
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
          slotProps={{

            select: {
              renderValue: (selectedValue) => {

                if (addOptionNone && selectedValue === '') {
                  return <em>{'None'}</em>
                }

                const selectedOption = options?.find(
                  (option) => (option.value ?? option.id ?? option.name) === selectedValue
                )
                
                if (selectedOption) {
                  return (
                    <View style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      width: '100%',
                      color: selectedOption.color ?? theme.colors.text
                    }}>
                      {selectedOption.name}
                      {selectedOption.icon ? selectedOption.icon : null}
                    </View>
                  )
                }

                return (
                  <View style={{ ...textStyle, color: theme.colors.text }}>
                    {selectedValue}
                  </View>
                )
              }
            }
          }}
        >
          {addOptionNone ? <MenuItem style={textStyle} value=""><em>{'None'}</em></MenuItem> : null}
          
          {value && !valueExistsInOptions && (
            <MenuItem value={value} style={{ display: 'none' }}>
              {value}
            </MenuItem>
          )}

          {options?.map((option) => (
            <MenuItem onClick={option.onSelect} style={textStyle} key={option.id ?? option.name} value={option.value ?? (option.id ?? option.name)}>
              <View style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '100%',
                color: option.color ?? theme.colors.text
              }}>
                {option.name}
                {option.icon ? option.icon : null}
              </View>
            </MenuItem>
          ))}
        </TextField>
      </FormControl>
    </View>
  )
}

export const Title = ({ children }) => {
  return (
    <View style={{
      color: '#606060',
      fontFamily: 'Inter',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: 'normal',
      letterSpacing: '0.24px',
      textTransform: 'uppercase'
    }}>
      {children}
    </View>
  )
}